import { render } from "./UserSubDetails.vue?vue&type=template&id=8d3cd12e&ts=true"
import script from "./UserSubDetails.vue?vue&type=script&lang=ts"
export * from "./UserSubDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__